module.exports = __webpack_public_path__ + "img/glsWhiteLogo.ba478583.png";